<template>
  <div>
    <feather-icon title="Export" icon="FileIcon" svgClasses="h-6 w-6 hover:text-primary cursor-pointer" @click="exportGameReport()"/>
    <feather-icon title="Import" icon="ArrowUpCircleIcon" svgClasses="h-6 w-6 hover:text-primary cursor-pointer ml-3" @click="openManualScoreUploadModal()" />

    <vs-popup
      class="holamundo custom-activity-wrap"
      title="Upload Scores Manually"
      :active.sync="popupActive3"
    >
      <div class="import-attendee-wrapper">
        <h4>Select Type</h4>
        <vs-radio
          v-model="downloadType"
          vs-value="exposcore"
          name="downloadType"
          >Scavenger Hunt Score</vs-radio
        >
        <vs-radio
          v-model="downloadType"
          vs-value="customscore"
          name="downloadType"
          class="ml-3"
          >Custom Score</vs-radio
        >
        <div class="template-download">
          <h4>Download the template</h4>
          <a
            color="primary"
            type="filled"
            class="mt-3 btn cursor-pointer"
            @click="downloadTemplate()"
            >Download</a
          >
        </div>
        <div class="upload-file mt-5">
          <h4>Upload your file</h4>
          <div class="file-up-section">
            <p>Upload file</p>
            <input
              type="file"
              id="customActivity_file"
              accept=".csv, .xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
            <vs-button
              color="rgb(76, 139, 246)"
              type="filled"
              class="sub-btn"
              @click="readCustomActivityXL"
              >Upload</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from "moment-timezone";
export default {
  name: 'CellRendererGmeActions',
  data(){
    return {
      popupActive3: false,
      downloadType: 'exposcore'
    }
  },
  methods: {
    openManualScoreUploadModal(){
      this.popupActive3 = true;
    },
    readCustomActivityXL(){
      let vm = this;
      var files = document.getElementById("customActivity_file").files;
      if (!files.length) {
            alert("Please Upload File!");
            return;
        } else {
            var validFileTypes = [
                ".csv",
                "csv",
                ".xlsx",
                "xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ];
            var f = files[0];
            var ext = f.name.split(".")[f.name.split(".").length - 1];
            if (!validFileTypes.includes(f.type) && !validFileTypes.includes(ext)) {
                alert("Only csv,excel file allowed.");
                return false;
            }

            var reader = new FileReader();
            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = XLSX.read(data, { type: "array" });
                let sheetName = vm.downloadType == 'customscore' ? 'CustomActivity' : 'ExpoActivity'
                let worksheet = workbook.Sheets[sheetName];
                if(!worksheet){ alert(`Sheet Name ${sheetName} not Exists!`); return false; }
                let dataArray = XLSX.utils.sheet_to_json(worksheet, {
                    header: 1                    
                });
                let activityArray = [];                
                if(vm.downloadType == 'customscore'){
                  for(let i=1;i<dataArray.length;i++){
                    if(dataArray[i].length){
                      activityArray.push({
                        actionTypeCode: dataArray[i][0] ? dataArray[i][0] : null,
                        scavengeDocId: dataArray[i][1] ? dataArray[i][1] : null,
                        email: dataArray[i][2] ? dataArray[i][2] : null,
                        quantity: dataArray[i][3] ? dataArray[i][3] : null,
                        reverse: dataArray[i][4] ? dataArray[i][4] : false
                      })
                    }
                  }
                  vm.uploadCustomActivity(activityArray);
                }
                else
                {
                  for(let i=1;i<dataArray.length;i++){
                    if(dataArray[i].length){
                      activityArray.push({
                        ScavengeId: dataArray[i][0] ? dataArray[i][0] : null,
                        DocId: dataArray[i][1] ? dataArray[i][1] : null,
                        Code: dataArray[i][2] ? dataArray[i][2] : null,
                        Score: dataArray[i][3] ? dataArray[i][3] : null,
                        MaxScore: dataArray[i][4] ? dataArray[i][4] : null,
                        IsPublished: dataArray[i][5] ? dataArray[i][5] : true,
                      })
                    }
                  }
                  vm.uploadExpoActivity(activityArray);
                }
            }
            reader.readAsArrayBuffer(f);
        }
    },
    uploadCustomActivity(dataArray){
      //console.log(dataArray)
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/uploadGameCustomActivity", dataArray)
        .then(res => {
          this.$vs.loading.close();
          if(res.status == 200){
            this.$vs.notify({
              position: "center",
              color: 'success',
              text: `Data updated`
            })
          }
          else{
            this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Data not updated!`
            })
          }
          window.location.reload();
        }).catch(err=>{
          this.$vs.loading.close();
          this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Something went wrong!`
            })
          window.location.reload();
        })
    },
    uploadExpoActivity(dataArray){
      //console.log(dataArray)
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/uploadGameExpoActivity", dataArray)
        .then(res => {
          this.$vs.loading.close();
          if(res.status == 200){
            this.$vs.notify({
              position: "center",
              color: 'success',
              text: `Data updated`
            })
          }
          else{
            this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Data not updated!`
            })
          }
          window.location.reload();
        }).catch(err=>{
          this.$vs.loading.close();
          this.$vs.notify({
              position: "center",
              color: 'warning',
              text: `Something went wrong!`
            })
          window.location.reload();
        })
    },
    downloadTemplate(){
      this.$vs.loading();
      this.$store.dispatch("exhibitorManagement/fetchExhibitors").then((res) => {
        this.$vs.loading.close();
        if(res.length){
          let data = res.map(item=>{
            return {
              'Exhibitor ID':item.ExhibitorId,
              'Exhibitor Name':item.Name
            }
          });
          /* this line is only needed if you are not adding a script tag reference */
          /* make the worksheet */
          let ws1 = XLSX.utils.json_to_sheet(data);
          /* add to workbook */
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws1, "Activities");
          let data2 = [
            {
              "ScavengeId": this.params.data.ScavengeId,
              "ExhibitorId": null,
              "Secret Code": null,
              "Score": null,
              "Max Score": null,
              "IsPublished": true
            }
          ]
          if(this.downloadType == 'customscore'){
            data2 = [{
              "Action Type Code": this.params.data.ScavengeId,
              "ExhibitorId": null,
              "Email": null,              
              "Quantity": null,
              "Reverse": false
            }]
          }
          let sheetName = this.downloadType == 'customscore' ? 'CustomActivity' : 'ExpoActivity'
          let ws2 = XLSX.utils.json_to_sheet(data2);
          XLSX.utils.book_append_sheet(wb, ws2, sheetName);
          /* generate an XLSX file */
          XLSX.writeFile(wb, "GamificationScoreUpload.xlsx");
        }
        else
        {
          this.$vs.notify({
              color: "warning",
              position: "top-center",
              text: "Exhibitor does not exists!",
            });
        }
      })
    },
    exportGameReport() {
      this.$vs.loading();
      this.$store
        .dispatch("LeaderboardManagement/fetchGameReport", this.params.data.ScavengeId)
        .then((res) => {
          let selectedRows = res.log;
          this.$vs.loading.close();
          if (selectedRows.length > 0) {
            var datarow = [];
            datarow.push("Name");
            datarow.push("Email");
            datarow.push("Scored from page");
            datarow.push("Code");
            datarow.push("Points Scored");
            datarow.push("Date and Time");
            var AttendeeData = [];
            AttendeeData.push(datarow);
            selectedRows.filter((row) => {
              datarow = [];
              datarow.push('"' + row.user_name + '"');
              datarow.push('"' + row.user_email + '"');
              datarow.push('"' + res.module_path + '"');
              datarow.push('"' + res.game_name + '"');
              datarow.push('"' + row.action_score + '"');
              datarow.push('"' + moment(row.date_time).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format("YYYY-MM-DD hh:mm") + '"');
              AttendeeData.push(datarow);
            });

            let csvContent = "data:text/csv;charset=utf-8,";
            var dt = new Date().toISOString().slice(0, 10);
            AttendeeData.forEach(function (rowArray) {
              let row = rowArray.join(",");
              csvContent += row + "\r\n";
            });
            var filename = "gamificationExport_" + "_" + dt + ".csv";
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            //link.setAttribute("id", "Participance_RT_" + row.TableId);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
            //---------------------------------------------------------------
          } else {
            this.$vs.dialog({
              type: "alert",
              color: "warning",
              title: "Download Report",
              text: "No data to export. ",
              //accept: this.deleteRecord,
              acceptText: "OK",
            });
          }
        });
    },
  }
}
</script>
